'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["index", "baseFilterFamily", "value"];
import { List } from 'immutable';
import FilterEditorOperatorDisplay from '../FilterEditorOperatorDisplay';
import FilterOperatorDescriptionType from '../propTypes/FilterOperatorDescriptionType';
import FilterOperatorErrorRecord from 'customer-data-filters/filterQueryFormat/FilterOperatorErrorRecord';
import PropTypes from 'prop-types';
import { memo } from 'react';
import always from 'transmute/always';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterEditorOperatorDescription = /*#__PURE__*/memo(props => {
  const {
      index,
      baseFilterFamily,
      value
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    filterFamily,
    operator
  } = value;
  return /*#__PURE__*/_jsx(FilterEditorOperatorDisplay, Object.assign({}, rest, {
    filterFamily: filterFamily || baseFilterFamily,
    handleOpenEdit: emptyFunction,
    handleOperatorRemove: emptyFunction,
    isReadOnly: true,
    isZeroLevel: true,
    operator: operator,
    path: List.of(index),
    showInvalidOptionErrors: false,
    validateOperator: always(FilterOperatorErrorRecord({
      error: false
    }))
  }));
});
FilterEditorOperatorDescription.propTypes = {
  baseFilterFamily: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  value: FilterOperatorDescriptionType
};
export default FilterEditorOperatorDescription;